import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageBarcelona = props => {
  return <CityLandingPage cityKey="Barcelona" cityConfig={cityContent.barcelona} {...props} />;
};

export default LandingPageBarcelona;
